import React, { Component } from 'react';
import DateRangePicker from 'react-bootstrap-daterangepicker';

// import 'bootstrap/dist/css/bootstrap.css';

import 'bootstrap-daterangepicker/daterangepicker.css';

class MyComponent extends Component {
    render() {
        return (
            <DateRangePicker initialSettings={{ startDate: '1/1/2014', endDate: '3/1/2014' }}>
                <input type="text" className="form-control" />
            </DateRangePicker>
        );
    }
}
export default MyComponent;
